import { Stack, TextField, MenuItem, InputAdornment } from "@material-ui/core";
import { Icon } from "@iconify/react";
import searchFill from "@iconify/icons-eva/search-fill";
import { ESTADOS_FILTRO } from "src/components/facturacion/estadoFacturacion";

const TIPOS = [
  { value: "TODOS", label: "Todos" },
  { value: "MES", label: "Mensual" },
  { value: "AÑO", label: "Anual" },
];

export default function FiltrosFacturacion({ filtros, setFiltros }) {
  const set = (campo) => (e) =>
    setFiltros((f) => ({ ...f, [campo]: e.target.value }));

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2} sx={{ p: 2.5 }}>
      <TextField
        fullWidth
        value={filtros.texto}
        onChange={set("texto")}
        placeholder="Buscar cliente o plan…"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon icon={searchFill} width={20} height={20} />
            </InputAdornment>
          ),
        }}
      />
      <TextField
        select
        label="Tipo"
        value={filtros.tipo}
        onChange={set("tipo")}
        sx={{ minWidth: 160 }}
      >
        {TIPOS.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        select
        label="Estado"
        value={filtros.estado}
        onChange={set("estado")}
        sx={{ minWidth: 160 }}
      >
        {ESTADOS_FILTRO.map((o) => (
          <MenuItem key={o.value} value={o.value}>
            {o.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
